import { AppConfig } from 'config'
import { initializeSupportChat, openSupportChat } from './support-chat'

class Service {
	/** Docs own one eagerly initialized launcher in the top-level platform window. */
	initializeSupport() {
		return initializeSupportChat()
	}
	openSupport() {
		return openSupportChat()
	}
	private get widget() {
		return window.HubSpotConversations
	}

	private get isAvailable() {
		return !!this.widget
	}

	init() {
		try {
			if (!['stage', 'production'].includes(AppConfig.ENV)) return
			if (!this.isAvailable) return

			this.widget.widget.load()
		} catch (error) {
			console.error('Chat init error:', error)
		}
	}

	open() {
		try {
			if (!this.isAvailable) return
			this.widget.widget.open()
		} catch (error) {
			console.error('Chat open error:', error)
		}
	}

	close() {
		try {
			if (!this.isAvailable) return
			this.widget.widget.close()
		} catch (error) {
			console.error('Chat close error:', error)
		}
	}

	hide() {
		try {
			if (!this.isAvailable) return
			this.widget.widget.remove()
		} catch (error) {
			console.error('Chat hide error:', error)
		}
	}

	show() {
		try {
			if (!this.isAvailable) return
			this.widget.widget.load()
		} catch (error) {
			console.error('Chat show error:', error)
		}
	}
}

export const ChatService = new Service()
